

import "react-multi-carousel/lib/styles.css";




import React from 'react';


const AboutUs = () => {
    return (
        <section className="about-us" id="aboutus">
            <h1 className="h1">ABOUT US</h1>
            <div className="about-us-container">
                <div className="about-us-box">
                    <h5 className="box-title">ABOUT BRAINOVA</h5>
                    <p className="box-content" style={{ color: "white" }}>
                        Brainova is the official student association of the CSE (Artificial Intelligence and Machine Learning) and (Cyber Security) department, established to foster innovation and collaboration in AI and Machine Learning. It was founded and inaugurated by Mr. S. Mohammed Jaleel (Founder & Chairman) on September 18th, 2024, in the presence of administrative members, with the support of our HOD and faculty members. Brainova aims to empower students through tech events, workshops, and symposiums, creating a dynamic platform for learning, research, and skill development in emerging technologies.
                    </p>
                </div>
                <hr className="horizontal-line" />
                <div className="about-us-box">
                    <h5 className="box-title">ABOUT NEURAVERSE'25</h5>
                    <p className="box-content" style={{ color: "white" }}>
                        Neuraverse'25 is an electrifying inter-collegiate symposium by 'Brainova', a student's association, uniting bright minds in tech and non-tech challenges. Experience innovation through thrilling competitions, insightful discussions, and hands-on activities. Show off your skills, collaborate, and push the boundaries of technology. Join us and be part of the future!
                    </p>
                </div>
                <hr className="horizontal-line" />
                <div className="about-us-box">

                    <h5 className="box-title">AIML DEPARTMENT</h5>
                    <p className="box-content" style={{ color: "white" }}>
                        The Department of Computer Science and Engineering (Artificial Intelligence & Machine Learning) was established in 2022 with a vision to excel in AI-driven education and research. Led by Dr. B. Guru Prakash, Head of the Department, we offer a cutting-edge curriculum that integrates core computer science with advanced AI and ML technologies. Our focus is on hands-on learning, industry collaborations, and research in areas like deep learning, data science, and robotics. With experienced faculty and state-of-the-art labs, we prepare students for dynamic careers in AI. We actively engage in workshops, hackathons, and innovative projects, shaping the future of intelligent computing.

                    </p>
                </div>
                <hr className="horizontal-line" />
                <div className="about-us-box">

                    <h5 className="box-title">CYBER DEPARTMENT</h5>
                    <p className="box-content" style={{ color: "white" }}>
                        The Department of Computer Science and Engineering (Cyber Security) was established in 2023 to equip students with expertise in cybersecurity, ethical hacking, and digital forensics. Led by Dr. B. Guru Prakash, Head of the Department, we offer a specialized curriculum that blends core computing with advanced security practices. Our focus is on hands-on learning, industry collaborations, and research in areas like network security, cryptography, and threat analysis. With experienced faculty and cutting-edge labs, we prepare students to tackle evolving cyber threats. We actively engage in workshops, hackathons, and real-world projects to develop future cybersecurity experts.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default AboutUs;
